import React from "react";

const FeatureCard = ({ icon, title, description }) => {
  const isImage = typeof icon === "string" && icon.length > 0;

  const imageSrc =
    isImage && !icon.startsWith("http")
      ? `https://www.programshouse.com/hr/public/storage/${icon}`
      : icon;

  return (
    <div className="relative flex min-h-[180px] flex-col rounded-2xl border border-gray-200 bg-white/10 p-6 shadow-sm transition hover:shadow-md">
      <div className="absolute -top-8 left-6 flex size-16 items-center justify-center rounded-full border border-gray-200 bg-white p-3 shadow">
        {isImage ? (
          <img
            src={imageSrc}
            alt={title || "Feature icon"}
            className="h-8 w-8 object-contain"
          />
        ) : icon ? (
          React.createElement(icon, {
            size: 26,
            className: "text-[#6989B7]",
          })
        ) : (
          <span className="size-8 rounded-full bg-primary/20" />
        )}
      </div>

      <h3 className="mt-8 line-clamp-2 min-h-[56px] text-xl font-semibold text-primary">
        {title}
      </h3>

      <p className="mt-2 line-clamp-4 flex-1 text-gray-500">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;